import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import {colors} from '../../tailwind.config';

// Kept close to homey-admin-app's plain Aura look (this is an internal tool -
// no redesign) - just wires Aura's primary color scale to the shared blue
// palette from tailwind.config.ts instead of introducing a new one.
export const AdminV2Theme = definePreset(Aura, {
  primitive: {
    ...colors,
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});
